import { Link, useNavigate } from "react-router-dom";
import StatusBadge from "../components/User-Profile/StatusBadge";
import LatestActivity from "../components/User-Profile/LatestActivity";
import Tabs from "../components/User-Profile/Tabs";
import { ProjectsList } from "../components/User-Profile/ProjectsList";
import { useEffect, useRef, useState } from "react";
import { LicensesTab } from "../components/User-Profile/LicenseTab";
import { useDispatch, useSelector } from "react-redux";
import { API_HOST } from "../api_utils";
import { toast, ToastContainer } from "react-toastify";
import { getAllProject } from "../Redux/Actions/projectActions";
import axios from "axios";
import {
  getUserProfile,
  updateProfile,
} from "../Redux/Actions/userProfileActions";
import { Camera, ContactRound } from "lucide-react";
import UpdateProfile from "../components/User-Profile/UpdateProfile";
import { getProfileStats } from "../API/Company-admin/userApi";

const errorTheme = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};
export default function AccountProfile(props) {
  const [tab, setTab] = useState("Overview");
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let hoverEffect = props.hover;
  const { userProfile } = useSelector((state) => state.userProfile);
  const { allProjectData } = useSelector((state) => state.allProjectData);
  const { userInfo } = useSelector((state) => state.userLogin);
  const [open, setOpen] = useState(false);
  const [coverSuccess, setCoverSuccess] = useState(false);
  const [coverLoading, setCoverLoading] = useState(false);
  const [profileSuccess, setProfileSuccess] = useState(false);
  const [profileLoading, setProfileLoading] = useState(true);
  const [name, setName] = useState(userInfo?.name);
  const [email, setEmail] = useState(userInfo?.email);
  const [pass, setPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [allowSubmit, setAllowSubmit] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userStats, setUserStats] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getProfileCounts = async () => {
    try {
      const data = await getProfileStats(userInfo.token);
      setUserStats(data);
    } catch (error) {
      console.log("Error getting profile counts");
    }
  };

  useEffect(() => {
    dispatch(getAllProject());
    getProfileCounts();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const coverImageHandler = async (files) => {
    setCoverLoading(true);

    let file = files[0];
    let formData = new FormData();
    formData.append("image", file);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_HOST}uploadRoutes/cover/${userInfo?._id}/cover`,
      formData,
      config
    );
    if (data) {
      setCoverLoading(false);
      setCoverSuccess(true);
    }
  };

  const profileImageHandler = async (files) => {
    setProfileLoading(true);

    let file = files[0];
    let formData = new FormData();
    formData.append("image", file);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_HOST}uploadRoutes/cover/${userInfo?._id}/profile`,
      formData,
      config
    );
    if (data) {
      setProfileLoading(false);
      setProfileSuccess(true);
    }
  };

  const updateProfileHandler = () => {
    if (name.length && email.length && !pass.length && !newPass.length) {
      dispatch(updateProfile({ name: name, email: email }));
      setOpen(false);
    }

    if (pass.length && newPass.length) {
      if (pass === newPass) {
        dispatch(updateProfile({ password: pass }));
        setOpen(false);
      } else {
        toast.error("passwords do not match", errorTheme);
      }
    }
    if (pass.length && !newPass.length) {
      toast.error("Please Confirm the password", errorTheme);
    }

    if (!name.length || !email.length) {
      toast.error("Name and Email Can't be empty", errorTheme);
    }
  };

  useEffect(() => {
    dispatch(getUserProfile());
  }, [coverSuccess, profileSuccess]);

  useEffect(() => {
    navigate(`?tab=${tab}`, { replace: true });
  }, [tab, navigate]);

  return (
    <div className="w-full mx-auto p-6 px-20 bg-white tailwind-wrapper">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-xl font-bold">Account Profile</h1>
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="bg-[#ED1C24] text-white px-4 py-1.5 rounded-md text-sm flex items-center gap-1.5"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-settings"
            >
              <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            Settings
          </button>
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200">
              <div className="px-4 py-2 text-sm text-gray-700 font-medium border-b border-gray-200">
                My Account
              </div>
              <button
                onClick={() => {
                  setOpen(true);
                  setDropdownOpen(false);
                }}
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mr-2"
                >
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                </svg>
                Edit Profile
              </button>

              <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mr-2"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Share Your Profile
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <div className="flex mb-6 rounded-md">
        <Tabs tab={tab} setTab={setTab} />
      </div>

      {tab === "Projects" && (
        <ProjectsList
          projects={
            allProjectData
              ? [...allProjectData].sort(
                  (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                )
              : []
          }
        />
      )}
      {/* {tab==="Licenses" &&
      <LicensesTab/>
      } */}

      {/* Main Content */}
      {tab === "Overview" && (
        <div className="flex flex-col md:flex-row gap-6">
          {/* Left Sidebar */}
          <div className="w-full md:w-1/3 lg:w-1/4 shadow-xl">
            <div className="rounded-lg p-6">
              <div className="relative mb-2">
                <label
                  htmlFor="fileInput"
                  className="cursor-pointer block"
                  onMouseEnter={() => setIsHovering(true)}
                  onMouseLeave={() => setIsHovering(false)}
                >
                  <div className="w-24 h-24 mx-auto rounded-full overflow-hidden relative">
                    <div
                      className={`absolute inset-0 bg-black/50 flex items-center justify-center transition-opacity duration-200 ${
                        isHovering ? "opacity-100" : "opacity-0"
                      }`}
                    >
                      <Camera className="w-8 h-8 text-white" />
                    </div>
                    <div
                      className={`w-full h-full flex items-center justify-center ${
                        userProfile?.profile_image ? "" : "bg-green-100"
                      }`}
                    >
                      {userProfile?.profile_image ? (
                        <img
                          src={userProfile.profile_image}
                          alt="Profile"
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <span className="text-2xl font-semibold text-green-600">
                          {userInfo?.name?.charAt(0)}
                        </span>
                      )}
                    </div>
                  </div>
                  <div
                    className={`mt-2 text-center text-sm text-gray-600 transition-opacity duration-200 ${
                      isHovering ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    Change Photo
                  </div>
                </label>
                <input
                  type="file"
                  id="fileInput"
                  accept="image/*"
                  className="hidden"
                  onChange={(e) => profileImageHandler(e.target.files)}
                />
              </div>
              <div className="text-center mb-6">
                <h2 className="font-bold text-lg">{userInfo?.name}</h2>
                {/* <p className="text-gray-500 text-sm">Project Manager</p> */}
              </div>

              <div className="grid grid-cols-2 justify-center items-center text-center mb-6">
                <div>
                  <p className="font-bold">
                    {userStats?.total_pages ? userStats.total_pages : 0}
                  </p>
                  <p className="text-gray-500 text-xs">Pages</p>
                </div>
                <div>
                  <p className="font-bold">
                    {allProjectData?.length ? allProjectData?.length : 0}
                  </p>
                  <p className="text-gray-500 text-xs">Projects</p>
                </div>
                <div>
                  <p className="font-bold">
                    {userStats?.total_template_fragments
                      ? userStats.total_template_fragments
                      : 0}
                  </p>
                  <p className="text-gray-500 text-xs">Template Fragments</p>
                </div>
                {userInfo?.company_admin && (
                  <div>
                    <p className="font-bold">
                      {userStats?.docker_generation_count
                        ? userStats.docker_generation_count
                        : 0}
                    </p>
                    <p className="text-gray-500 text-xs">Docker Generation</p>
                  </div>
                )}
                <div>
                  <p className="font-bold">
                    {userStats?.total_custom_tables
                      ? userStats.total_custom_tables
                      : 0}
                  </p>
                  <p className="text-gray-500 text-xs">Data Tables/Models</p>
                </div>
              </div>

              <div className="space-y-3">
                <div className="flex items-center gap-2 text-sm">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-mail"
                  >
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </svg>
                  <span>{userInfo?.email}</span>
                </div>
                {/* <div className="flex items-center gap-2 text-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-phone"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <span>(+1-876) 8654 239 581</span>
              </div> */}
                {/* <div className="flex items-center gap-2 text-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map-pin"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>New York</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-link"
                >
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                </svg>
                <span>https://shadcnuikit.com</span>
              </div> */}
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="w-full md:w-2/3 lg:w-3/4">
            <div className="flex justify-between items-center mb-6">
              <h2 className="font-bold text-lg">Latest Activity</h2>
            </div>
            {allProjectData?.length ? (
              [...allProjectData]
                .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                .map((project, index) => (
                  <LatestActivity
                    key={index}
                    index={index}
                    activity={project}
                  />
                ))
            ) : (
              <div className="p-10 border rounded-md text-sm text-center">
                You Don't Have any projects yet!!!
              </div>
            )}
          </div>
        </div>
      )}

      <UpdateProfile
        open={open}
        handleClose={handleClose}
        name={name}
        setName={setName}
        email={email}
        setEmail={setEmail}
        pass={pass}
        setPass={setPass}
        newPass={newPass}
        setNewPass={setNewPass}
        allowSubmit={allowSubmit}
        setAllowSubmit={setAllowSubmit}
        updateProfileHandler={updateProfileHandler}
      />
    </div>
  );
}
